module.exports = __webpack_public_path__ + "img/track-event.b06181cf.svg";